import React, { useState } from "react";

interface ChoiceBoxProps {
  option1: string;
  option2: string;
  onChoice: (choice: boolean) => void;
}

const ChoiceBox: React.FC<ChoiceBoxProps> = ({ option1, option2, onChoice }) => {
  const [selected, setSelected] = useState<boolean | null>(null);

  const handleSelect = (choice: boolean) => {
    setSelected(choice);
    onChoice(choice);
  };

  return (
    <div style={{ display: "flex", justifyContent: "space-around", margin: "20px" }}>
      <div
        onClick={() => handleSelect(true)}
        style={{
          border: selected === true ? "2px solid #220A6E" : "1px solid gray",
          padding: "20px",
          cursor: "pointer",
          backgroundColor: selected === true ? "#fff" : "#fff",
        }}
      >
        {option1}
      </div>
      <div
        onClick={() => handleSelect(false)}
        style={{
          border: selected === false ? "2px solid #220A6E" : "1px solid gray",
          padding: "20px",
          cursor: "pointer",
          backgroundColor: selected === false ? "#fff" : "#fff",
        }}
      >
        {option2}
      </div>
    </div>
  );
};

export default ChoiceBox;
